<template>
    <form clas="form" @submit.prevent="$emit('submit')">
        <h4>{{$t('support.wizard.label_title_stage')}}</h4>
        <ul class="list--radio">
            <li v-for="option in options" :key="option" class="radio">
                <input type="radio" v-gen.id="option" v-gen.name="'title'" :value="option" v-model="selectedTitle"
                       required class="radio__rb">
                <label v-gen.for="option" class="radio__label">
                    <p class="radio__text">
                        {{$t('support.wizard.title.header_' + option)}}
                        <span>
                            {{$t('support.wizard.title.label_' + option)}}
                        </span>
                    </p>

                </label>
            </li> 
        </ul>
        <button type="submit" class="button--cta" :disabled="!canSubmit">
            {{$t('support.wizard.button_continue')}}
        </button>
    </form>
</template>

<script>
    import Vue from 'vue';
    import {Component} from 'vue-property-decorator';
    import {GET_TITLE_OPTIONS, GET_TITLE, SET_TITLE} from '../../store/modules/support_wizard';

    @Component
    export default class WizardTitleSelect extends Vue {
    
        created() {
            window.scrollTo(0,0);
        }
        get options() {
            return this.$store.getters[GET_TITLE_OPTIONS];
        }

        get selectedTitle() {
            return this.$store.getters[GET_TITLE].code;
        }

        set selectedTitle(code) {
            const text = this.getTitleText(code);
            this.$store.commit(SET_TITLE, {code, text});
        }

        getTitleText(code) {
            //return this.$t(`common.support.title.${code}`);
            return this.$t(`support.wizard.title.header_${code}`);
        }

        get canSubmit() {
            return !!this.selectedTitle;
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/support/WizardTitleSelect.vue